<template lang="pug">
    .b2b-page-approval-flow
      ods-module.box-card
        div(slot='header')
          ods-row.info(type='flex', align='middle')
            ods-col(:span='8')
              div {{ $t('centres.title_admin_approval_flow') }}
            ods-col(:span='16')
              ods-row(type='flex', justify='end')
                ods-tooltip(:content='$t("centres.delete_centre")', placement='bottom')
                  ods-button(
                    v-if='centreApprovalAmountForm.id'
                    type='primary',
                    icon='ods-icon-delete',
                    size='small',
                    circle,
                    @click.native='removeCentreApprovalAmount')
                    | {{ $t('centres.delete_approval_flow') }}
        ods-form(
          ref='centreApprovalAmountForm',
          :model='centreApprovalAmountForm',
          :rules='rulesLevelForm'
          label-width='14rem',
          label-position='top',
          size='small',
          status-icon)
          ods-row(type='flex')
            ods-col(:span='10')
              ods-form-item(
                prop='centreDescription',
                :label='$t("centres.entity_table.nameCentre")')
                ods-input(
                  v-model='centreApprovalAmountForm.centreDescription',
                  disabled)
              ods-form-item(
                prop='amount',
                :label='$t("centres.approval_flow_data.amount")')
                ods-input(
                  v-model='centreApprovalAmountForm.amount')
              ods-form-item(
                :label='$t("centres.approval_flow_data.purchase_order")',
                prop='enable')
                ods-switch(
                  :active-color='primaryColor',
                  inactive-color='#D5DCE0',
                  v-model='centreApprovalAmountForm.purchaseOrder')
            ods-col(:span='4')
            ods-col(:span='10')
              ods-form-item(
                v-show="false",
                prop='centreCode',
                :label='$t("centres.approval_flow_data.code")')
                ods-input(
                  v-model='centreApprovalAmountForm.centreCode')
              ods-form-item(
                prop='description',
                :label='$t("centres.approval_flow_data.description")')
                ods-input(
                  v-model='centreApprovalAmountForm.description')
              ods-form-item(
                prop='amountTo',
                :label='$t("centres.approval_flow_data.amountTo")')
                ods-input(
                  v-model='centreApprovalAmountForm.amountTo')

      ods-row.form-actions()
        ods-col(:span='24')
          ods-tooltip(:content='$t("buttons.btnSaveChanges_tooltip")', placement='bottom')
            ods-button(
              type='primary',
              size='large'
              @click='addOrUpdateCentreApprovalAmount("centreApprovalAmountForm")')
              | {{ $t('buttons.btnSaveChanges') }}
          ods-tooltip(:content='$t("buttons.btnCancel")', placement='bottom')
            ods-button(
              ref='buttonCancel',
              type='neutral',
              size='large'
              @click='cancelcentreApprovalAmountForm()')
              | {{ $t('buttons.btnCancel') }}

        ods-module.collapse(v-if='!isNewFlow')
          ods-accordion(v-model='activateApprovalFlow', @change='')
            ods-accordion-item(name='1')
              template(slot='title')
                span {{ $t('centres.approval_flow') }}
                span.info(v-show='!dataApprovalLevel.length') {{ $t('centres.no_aproval_flow_data') }}

              //- Tabla de niveles de aprobación (centre_approval_level)
              ods-table(
                v-if='dataApprovalLevel.length > 0 ',
                :data='dataApprovalLevel',
                :default-sort="{ prop: 'level', order: 'ascending' }",
                style='width: 100%',
                @cell-mouse-enter='handleCellMouseEnterApprovalLevel',
                highlight-current-row,
                size='mini',
                fit)
                ods-table-column(
                  prop='level',
                  :label='$t("centres.centre_approval_level_table.level")',
                  :show-overflow-tooltip='true',
                  sortable='')
                ods-table-column(
                  prop='user',
                  :label='$t("centres.centre_approval_level_table.user")',
                  :show-overflow-tooltip='true',
                  sortable='')
                ods-table-column(
                  prop='notification',
                  :label='$t("centres.centre_approval_level_table.notification")',
                  :show-overflow-tooltip='true',
                  sortable='')
                  template(slot-scope='scope')
                    span(v-if="scope.row.notification === true") {{ $t('msg_generics.question.yes') }}
                    span(v-else-if="scope.row.notification === false") {{ $t('msg_generics.question.no') }}
                ods-table-column(
                  label='',
                  width='80')
                  template(slot-scope='scope')
                    ods-tooltip(:content='$t("buttons.btnDelete")', placement='bottom')
                      ods-button(
                        type='neutral',
                        @click='removeCentreApprovalLevel(scope.$index)')
                        ods-icon(name='close', size='16')
              ods-tooltip(:content='$t("party_detail.buttons.add_contact_data")', placement='bottom')
                ods-button.button-collapse(
                  icon='ods-icon-plus',
                  size='small',
                  circle,
                  @click.native='showDialogAddApprovalLevel()')
                  | {{ $t('party_detail.buttons.add_contact_data') }}

      //- Dialogo añadir nivel de aprobación
      ods-dialog(
        ref='dialogAllApprovalLevel',
        :title='$t("centres.dialog_add_approval_level.title")',
        :visible.sync='isShowDialogAddApprovalLevel',
        @close='handleCloseDialogApprovalLevel',
        width='30%')
        ods-form(
          ref='formDialogAddApprovalLevel',
          :model='addApprovalLevelForm',
          :rules='rulesAddApprovalLevelForm')
            ods-form-item(
              :label='$t("centres.dialog_add_approval_level.level.label")',
              prop='level')
              ods-select(
                :no-match-text='$t("msg_generics.no_match")',
                v-model='addApprovalLevelForm.level',
                filterable,
                :placeholder='$t("centres.dialog_add_approval_level.level.placeholder")')
                ods-option(
                  v-for='option in comboLevelList',
                  :key='option.value',
                  :label='$t(option.label)',
                  :value='option.value')
            ods-form-item(
              :label='$t("centres.dialog_add_approval_level.user.label")',
              prop='user')
              ods-select(
                :no-match-text='$t("msg_generics.no_match")',
                v-model='addApprovalLevelForm.user',
                filterable,
                :placeholder='$t("centres.dialog_add_approval_level.user.placeholder")')
                ods-option(
                  v-for='option in approvalUserList',
                  :key='option.value',
                  :label='option.label',
                  :value='option.value')
            ods-form-item(
              :label='$t("centres.dialog_add_approval_level.notification.label")',
              prop='notification')
              ods-select(
                :no-match-text='$t("msg_generics.no_match")',
                v-model='addApprovalLevelForm.notification',
                filterable,
                :placeholder='$t("centres.dialog_add_approval_level.notification.placeholder")')
                ods-option(
                  v-for='option in notificationOptionsList',
                  :key='option.value',
                  :label='option.label',
                  :value='option.value')
        span.dialog-footer(slot='footer')
          ods-tooltip(:content='$t("buttons.btnAdd")', placement='bottom')
            ods-button(
              type='primary',
              @click.native='insertCentreApprovalLevelOnDatabase("formDialogAddApprovalLevel")')
              | {{ $t('buttons.btnAdd') }}
  </template>

<script>
import { mapGetters, mapActions } from 'vuex'
import B2bTimeline from '@/components/B2bTimeline'
import Utils from '@/components/shared/Utils'
import router from '@/router/index'

export default {
  name: 'b2b-page-approval-flow',
  mixins: [Utils],
  data () {
    return {
      activateApprovalFlow: ['1'],
      centreApprovalAmountForm: {
        centreDescription: null,
        amount: null,
        centreCode: null,
        description: null,
        id: null,
        purchaseOrder: null,
        amountTo: null
      },
      centreApprovalAmountFormCopy: {}, // mantiene una copia original de los datos
      // Validaciones
      centreApprovalAmountFormRules: {
        amount: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          },
          {
            pattern: /^\d+([.,]\d+)?$/, // permitimos números decimales
            message: this.$t('msg_generics.number_required'),
            trigger: 'change'
          }
        ],
        amountTo: [
          {
            pattern: /^\d+([.,]\d+)?$/, // permitimos números decimales
            message: this.$t('msg_generics.number_required'),
            trigger: 'change'
          }
        ],
        description: [
          {
            max: 255,
            message: this.$t('msg_generics.max_num_character', { max: 255 }),
            trigger: 'change'
          }
        ]
      },

      // DATOS DEL FLUJO DE APROBACIÃ“N
      dataApprovalLevel: [], // lista de niveles de aprobación
      currentRowApprovalLevel: {}, // fila seleccionada, para el borrado de un nivel de aprobación
      isShowDialogAddApprovalLevel: false,
      approvalUserList: [], // lista de usuarios seleccionables como aprobadores
      isNewFlow: false, // false si es un flujo existente (estamos editando), true si es nuevo (estamos creando)

      addApprovalLevelForm: {
        id: null,
        level: null,
        user: null,
        notification: null
      },

      rulesAddApprovalLevelForm: {
        level: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'submit'
          }
        ],
        user: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'submit'
          }
        ],
        notification: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'submit'
          }
        ]
      },

      // comboTypeList: [],

      comboLevelList: [
        { value: '1', label: '1' },
        { value: '2', label: '2' },
        { value: '3', label: '3' },
        { value: '4', label: '4' },
        { value: '5', label: '5' },
        { value: '6', label: '6' },
        { value: '7', label: '7' },
        { value: '8', label: '8' },
        { value: '9', label: '9' },
        { value: '10', label: '10' }
      ],

      notificationOptionsList: [
        { value: 'true', label: this.$t('msg_generics.question.yes') },
        { value: 'false', label: this.$t('msg_generics.question.no') }
      ]

    }
  },

  components: {
    B2bTimeline
  },

  computed: {
    ...mapGetters([
      'optionsFilterMediaType',
      'countries',
      'canAdminIndra',
      'primaryColor'
    ]),

    rulesLevelForm () {
      const checkIntegerNumber = (rule, value, callback) => {
        if (value !== undefined && value !== null && value !== '') {
          if (!this.checkCorrectNumber(value, true)) {
            if (this.getCharFailedNumeric(value) === 'NoNumeric') {
              callback(new Error(this.$t('msg_generics.format_invalid')))
            } else {
              callback(new Error(this.$t('msg_generics.format_invalid') + '. ' + this.$t('msg_generics.character_invalid') + this.getCharFailedNumeric(value)))
            }
          } else if (this.countDecimals(value) > 6) {
            callback(new Error(this.$t('msg_generics.max_decimals', { max: 6 })))
          }
          callback()
        }
        callback()
      }
      const checkMaxValue = (rule, value, callback) => {
        if (value.toString().replace(',', '.') >= 1000000) {
          callback(new Error(this.$t('msg_generics.max_value', { max: 1000000 })))
        }
        callback()
      }
      return {
        description: [
          { max: 2500, message: this.$t('validations.maxlenght', { maxlenght: 2500 }), trigger: 'change' }
        ],
        amount: [
          { required: true, message: this.$t('msg_generics.field_required'), trigger: 'change' },
          { validator: checkIntegerNumber, trigger: 'change' },
          { validator: checkMaxValue, trigger: 'change' }
        ],
        amountTo: [
          { validator: checkIntegerNumber, trigger: 'change' },
          { validator: checkMaxValue, trigger: 'change' }
        ]
      }
    }
  },

  methods: {
    ...mapActions([
      'getCentreApprovalAmountById', // Consulta de datos de centre_approval_amount por id
      'getCentreApprovalAmount', // Consulta de datos de centre_approval_amount
      'insertOrUpdateCentreApprovalAmount', // Crea/actualiza un flujo de aprobación para el centro en 'centre_approval_amount'
      'deleteCentreApprovalAmount', // Elimina un flujo de aprobación para el centro en 'centre_approval_amount'
      'getCentreApprovalLevel', // Consulta de datos de los niveles de aprobaación de un centro en 'centre_approval_level'
      'getUsersForApprovalLevel', // Consulta de usuarios seleccionables como aprobadores para un nivel de aprobación
      'insertCentreApprovalLevel', // Crea un nivel de aprobación para un centro en 'centre_approval_level'
      'deleteCentreApprovalLevel' // Elimina un nivel de aprobación para un centro en 'centre_approval_level'
    ]),

    //  Reseteo al cerrar dialogo
    handleCloseDialogApprovalLevel () {
      this.$refs.formDialogAddApprovalLevel.resetFields()
    },

    showDialogAddApprovalLevel () {
      this.isShowDialogAddApprovalLevel = true
      // Get datos de los usuarios seleccionables como aprobadores
      this.getUsersForApprovalLevelOnDatabase()
    },

    async getCentreApprovalAmountOnDatabase () {
      // Get datos de centre_approval_amount
      try {
        console.log('cenntreId on route.params: ', this.$route.params.centreId)
        console.log('centreApprovalAmountId on route.params: ', this.$route.params.centreApprovalAmountId)
        if (this.$route.params.centreId !== null && this.$route.params.centreId !== undefined) {
          const data = await this.getCentreApprovalAmountById({ centreId: this.$route.params.centreId, centreApprovalAmountId: this.$route.params.centreApprovalAmountId })
          console.log('data on charge: ', data)
          if (data.length === 0) {
            this.resetApprovalAmountForm() // Ponemos los valores por defecto para la creación de un nuevo flujo
            this.centreApprovalAmountFormCopy.amount = 0
            this.centreApprovalAmountFormCopy.centreDescription = sessionStorage.getItem('centreDescription')
            this.centreApprovalAmountFormCopy.description = ''
            this.centreApprovalAmountFormCopy.purchaseOrder = false // TODO ver si es false o 0
            this.centreApprovalAmountFormCopy.amountTo = ''
            this.isNewFlow = true // Es nuevo flujo, habrá que insertarlo
          } else {
            this.centreApprovalAmountForm = data[0]
            if (this.centreApprovalAmountForm.amountTo !== null) {
              this.centreApprovalAmountForm.amountTo = this.$n(this.centreApprovalAmountForm.amountTo, 'max_decimal')
            }
            this.centreApprovalAmountForm.amount = this.$n(this.centreApprovalAmountForm.amount, 'max_decimal')
            this.centreApprovalAmountFormCopy = { ...data[0] }
            this.isNewFlow = false // No es nuevo flujo, estamos editando uno existente
          }
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    resetApprovalAmountForm () {
      this.centreApprovalAmountForm = {
        centreDescription: sessionStorage.getItem('centreDescription'),
        amount: 0,
        description: null,
        id: null
      }
    },

    // Crea un flujo de aprobación para el centro
    async addOrUpdateCentreApprovalAmount (formName) {
      let load = null
      if (this.centreApprovalAmountForm.id == null) {
        load = this.$loading({
          lock: true,
          text: this.$t('party_detail.load.add_approval_amount')
        })
      } else {
        load = this.$loading({
          lock: true,
          text: this.$t('party_detail.load.modify_approval_amount')
        })
      }
      try {
        const params = {
          centreId: this.$route.params.centreId,
          projectId: this.$route.params.projectId,
          description: this.centreApprovalAmountForm.description,
          amountFrom: this.centreApprovalAmountForm.amount.toString().replace(',', '.'),
          id: this.centreApprovalAmountForm.id,
          purchaseOrder: this.centreApprovalAmountForm.purchaseOrder,
          amountTo: this.centreApprovalAmountForm.amountTo !== undefined && this.centreApprovalAmountForm.amountTo !== null ? this.centreApprovalAmountForm.amountTo.toString().replace(',', '.') : undefined
        }
        console.log('params addOrUpdateCentreApprovalAmount: ', params)
        // Validamos los datos
        if (this.validateApprovalAmount(params)) {
          const dataInsert = await this.insertOrUpdateCentreApprovalAmount(params) // insertamos el nuevo flujo de aprobación
          console.log('dataInsert: ', dataInsert)
          if (dataInsert === null || dataInsert === undefined || dataInsert.data === '') {
            this.$notify({
              title: this.$t('party_detail.notify.error_approval_amount_data'),
              type: 'error',
              position: 'top-right',
              customClass: 'b2b-notification-error',
              Duration: 10000
            })
          }
          if (this.centreApprovalAmountForm.id == null) {
            // Notificamos la creación de un nuevo flujo de aprobación
            this.$notify({
              title: this.$t('party_detail.notify.add_approval_amount_data'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              Duration: 10000
            })
          } else {
            // Notificamos la actualización del flujo de aprobación
            this.$notify({
              title: this.$t('party_detail.notify.modify_approval_amount_data'),
              type: 'success',
              position: 'top-right',
              customClass: 'b2b-notification-success',
              Duration: 10000
            })
          }
          this.$route.params.centreApprovalAmountId = dataInsert.data.id

          await this.getCentreApprovalAmountOnDatabase() // recargamos los datos
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Elimina el flujo de aprobación del centro
    async removeCentreApprovalAmount () {
      const load = this.$loading({
        lock: true,
        text: this.$t('party_detail.load.delete_approval_amount')
      })

      try {
        await this.deleteCentreApprovalAmount({
          centreId: this.$route.params.centreId,
          projectId: this.$route.params.projectId,
          centreApprovalAmountId: this.$route.params.centreApprovalAmountId
        })
        this.$notify({
          title: this.$t('party_detail.notify.delete_approval_amount_data'),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
        const pageCentreName = 'page-approval-flows'
        console.log('params', this.$route.params)
        router.push({
          name: pageCentreName,
          params: {
            centreId: this.$route.params.centreId,
            centreCode: this.$route.params.centreCode,
            projectName: this.$route.params.projectName,
            partyName: this.$route.params.partyName
          }
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async getCentreApprovalLevelOnDatabase () {
      // Get datos de centre_approval_level
      try {
        if (this.$route.params.centreId !== null && this.$route.params.centreId !== undefined && this.$route.params.centreApprovalAmountId !== null && this.$route.params.centreApprovalAmountId !== undefined) {
          const data = await this.getCentreApprovalLevel({ centreId: this.$route.params.centreId, centreApprovalAmountId: this.$route.params.centreApprovalAmountId })
          this.dataApprovalLevel = data
          console.log('dataApprovalLevel on charge: ', this.dataApprovalLevel)
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    // Crea un nivel de aprobación para el flujo de aprobación del centro
    async insertCentreApprovalLevelOnDatabase (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const load = this.$loading({
            lock: true,
            text: this.$t('party_detail.load.add_approval_level')
          })
          try {
            const params = {
              centreApprovalAmountId: this.$route.params.centreApprovalAmountId,
              centreId: this.$route.params.centreId,
              projectId: this.$route.params.projectId,
              level: this.addApprovalLevelForm.level,
              userId: this.addApprovalLevelForm.user,
              notification: this.addApprovalLevelForm.notification
            }
            console.log('params insertCentreApprovalLevelOnDatabase: ', params)
            // Validamos posibles repetidos
            if (this.validateApprovalLevelRepeat(params)) {
              await this.insertCentreApprovalLevel(params) // insertamos el nuevo flujo de aprobación
              await this.getCentreApprovalLevelOnDatabase() // recargamos los datos
              // Notificamos la creación de un nuevo flujo de aprobación
              this.$notify({
                title: this.$t('party_detail.notify.add_approval_level_data'),
                type: 'success',
                position: 'top-right',
                customClass: 'b2b-notification-success',
                Duration: 10000
              })
              this.isShowDialogAddApprovalLevel = false
            }
          } catch (error) {
            this.getNotificationErrorMessage(error)
          } finally {
            load.close()
          }
        } else {
          console.log('error submit!!!!')
        }
      })
    },

    // Elimina el nivel de aprobación del flujo de aprobación del centro
    async removeCentreApprovalLevel () {
      const load = this.$loading({
        lock: true,
        text: this.$t('party_detail.load.delete_approval_level')
      })

      try {
        // Primero validamos que el nivel que se pretende eliminar es el más alto
        if (this.validateApprovalLevelOnDelete(this.currentRowApprovalLevel.level)) {
          await this.deleteCentreApprovalLevel({
            centreId: this.$route.params.centreId,
            projectId: this.$route.params.projectId,
            levelId: this.currentRowApprovalLevel.id
          })
          await this.getCentreApprovalLevelOnDatabase() // recargamos los datos
          this.$notify({
            title: this.$t('party_detail.notify.delete_approval_level_data'),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async getUsersForApprovalLevelOnDatabase () {
      try {
        if (this.$route.params.centreId !== null && this.$route.params.centreId !== undefined &&
          this.$route.params.projectId !== null && this.$route.params.projectId !== undefined &&
            this.$route.params.partyId !== null && this.$route.params.partyId !== undefined) {
          const data = await this.getUsersForApprovalLevel({ centreId: this.$route.params.centreId, projectId: this.$route.params.projectId, partyId: this.$route.params.partyId })
          this.approvalUserList = data.map(user => {
            return {
              label: `${user.name} ${user.firstSurname} ${user.secondSurname || ''} (${user.username})`,
              value: user.id
            }
          })
          console.log('approvalUserList: ', this.approvalUserList)
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    handleCellMouseEnterApprovalLevel (row, column, cell, event) {
      this.currentRowApprovalLevel = row
    },

    // Limpia los datos del formulario
    async cancelcentreApprovalAmountForm () {
      const load = this.$loading({
        lock: true,
        text: this.$t('project_detail.load.cancel')
      })
      try {
        // Quitamos el foco del boton
        this.$refs.buttonCancel.$el.blur()
        // Reseteamos
        this.centreApprovalAmountForm = this.centreApprovalAmountFormCopy
        this.$refs.centreApprovalAmountForm.clearValidate()
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Validaciones para crear un flujo de aprobación para el centro
    validateApprovalAmount (entityToAdd) {
      // Verificamos que los campos no están vacíos
      if (entityToAdd.amountFrom !== null && entityToAdd.amountFrom >= 0) {
        return true
      } else {
        this.$notify({
          title: this.$t('centres.approval_amount_empty'),
          type: 'error',
          position: 'top-right',
          customClass: 'b2b-notification-error',
          duration: 10000
        })
        return false
      }
    },

    // Validaciones para insertar un nivel de aprobación
    // Valida si el dato se ha insertado previamente. TRUE OK FALSE KO
    validateApprovalLevelRepeat (entityToAdd) {
      // Verificamos que los campos no están vacíos
      if (entityToAdd.level !== null && entityToAdd.user !== null && entityToAdd.notification !== null) {
        // Verificamos que la lista no esta vacia
        if (this.dataApprovalLevel !== null && this.dataApprovalLevel.length > 0) {
          const existingLevels = this.dataApprovalLevel.map(item => item.level)
          console.log('existingLevels: ', existingLevels)
          // Verificamos que el nivel que se intenta añadir sea el siguiente válido:
          for (let i = 1; i < entityToAdd.level; i++) {
            if (!existingLevels.includes(i)) {
              console.log('Nivel que falta por insertar: ', i)
              this.$notify({
                title: this.$t('centres.data_approval_level_not_valid'),
                type: 'error',
                position: 'top-right',
                customClass: 'b2b-notification-error',
                duration: 10000
              })
              return false
            }
          }
          // Verificamos que no se ha añadido previamente el mismo nivel para el mismo usuario:
          console.log('dataApprovalLevel: ', this.dataApprovalLevel)
          console.log('entityToAdd: ', entityToAdd)
          for (const entity of this.dataApprovalLevel) {
            if (Number(entity.level) === Number(entityToAdd.level) &&
                  entity.idUser === entityToAdd.userId) {
              this.$notify({
                title: this.$t('centres.data_approval_level_repeat'),
                type: 'error',
                position: 'top-right',
                customClass: 'b2b-notification-error',
                duration: 10000
              })
              return false
            }
          }
        } else {
          // Si la lista está vacía, solo permitimos añadir el nivel 1
          if (Number(entityToAdd.level) === 1) {
            return true
          } else {
            console.log('Nivel que se inserta: ', entityToAdd.level)
            this.$notify({
              title: this.$t('centres.data_approval_level_not_valid'),
              type: 'error',
              position: 'top-right',
              customClass: 'b2b-notification-error',
              duration: 10000
            })
            return false
          }
        }
      } else {
        this.$notify({
          title: this.$t('centres.data_approval_level_empty'),
          type: 'error',
          position: 'top-right',
          customClass: 'b2b-notification-error',
          duration: 10000
        })
        return false
      }
      return true
    },

    // Validaciones para el borrado de un nivel de aprobación
    validateApprovalLevelOnDelete (level) {
      // Verificamos que la lista no esta vacia
      if (this.dataApprovalLevel !== null && this.dataApprovalLevel.length > 0) {
        // Paso 1: Encontrar el nivel más alto en dataApprovalLevel
        const highestLevel = this.dataApprovalLevel.reduce((max, entity) => {
          return entity.level > max ? entity.level : max
        }, 0)
        console.log('highestLevel: ', highestLevel)

        // Paso 2: Comparar level con el nivel más alto
        if (level === highestLevel) {
          return true
        } else {
          console.log('level: ', level)
          console.log('dataApprovalLevel: ', this.dataApprovalLevel)
          // Paso 3: Aunque no sea el más alto, si hay otro usuario para ese mismo nivel, permitimos la eliminación
          const usersWithLevel = this.dataApprovalLevel.filter(entity => entity.level === level)
          console.log('Num usuarios con el mismo nivel: ', usersWithLevel.length)
          if (usersWithLevel.length > 1) {
            return true
          } else {
            this.$notify({
              title: this.$t('centres.approval_level_delete_not_allowed'),
              type: 'error',
              position: 'top-right',
              customClass: 'b2b-notification-error',
              duration: 10000
            })
            return false
          }
        }
      }
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = this.$i18n.messages.es.error.e401
          break
        case 403:
          errorSms = this.$i18n.messages.es.error.e403
          break
        case 404:
          errorSms = error.data.message
          break
        case 409:
          errorSms = error.data.message
          break
        case 500:
          errorSms = error.data.message
          break
        default:
          errorSms = this.$i18n.messages.es.error.default
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('centres.load.text_load_init_data')
    })
    try {
      this.centreApprovalAmountForm.centreDescription = sessionStorage.getItem('centreDescription')
      // Get datos de centre_approval_amount
      if (this.$route.params.centreApprovalAmountId !== null && this.$route.params.centreApprovalAmountId !== undefined) {
        await this.getCentreApprovalAmountOnDatabase()
        await this.getCentreApprovalLevelOnDatabase()
      } else {
        this.isNewFlow = true // Es nuevo flujo, habrá que insertarlo
        this.resetApprovalAmountForm()
      }
    } catch (error) {
      console.log('created CATCH: ', error)
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}
</script>

  <style lang="scss" scoped>
  .b2b-page-approval-flow {
    padding: 40px 40px 40px 40px;

    ::v-deep .ods-module{
      &__header{
        background-color: var(--color-bg-hover-2);
        padding: 0px;
        .info{
          margin-left: 40px;
          margin-right: 40px;
          height: 72px;
          color: var(--color-bg-interactive);
          size: 16px;
          line-height: 24px;
        }
      }

      &__body{
        padding: 32px;
        .info{
          padding-bottom: 32px;
        }
      }
    }

    .form-actions{
      padding-top: 40px;
      padding-bottom: 40px;
      .ods-button{
        float: right;
      }
    }

    .collapse{
      margin-top: 110px;
      .info {
        margin-left: 1rem;
        color: var(--color-txt-secondary);
      }

      ::v-deep .ods-table{
        th {
          padding: rem(0);
          padding-top: rem(4);

          .cell {
            font-weight: 500;
          }
        }
        &__row{
          .ods-button {
            padding: 0px;
            margin-left: 0px;
            margin-right: 0px;
            i {
              margin-left: 0px;
            }
          }
          .first-button {
            padding: 0px;
            margin-left: 0px;
            margin-right: rem(12);
            i {
              margin-left: 0px;
            }
          }
        }
      }

      .button-collapse {
        float: right;
        margin-top: 1rem;
      }

      ::v-deep .ods-module{
        &__body{
          padding: 0px;
        }
      }
    }  ::v-deep .ods-form-item.hidden label.ods-form-item__label {
      color: transparent !important;
    }
    ::v-deep .ods-form-item.hidden .ods-input.is-disabled .ods-input__inner {
      background-color: transparent !important;
      border-color: transparent !important;
    }
  }
  </style>
